/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * DefaultForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { InputField } from 'cx-ui-components';

export default function DefaultForm({ isSaving, inherited, userHasUpdatePermission, sidePanelUpdatePermissions, isMsteamsUserSyncing, integrationType }) {
  const msTeamsUpdatePermission = integrationType === 'ms-teams' ? sidePanelUpdatePermissions.msTeamsUpdatePermission : true
  return (
    <>
      <InputField
        name="name"
        label="Name *"
        componentType="input"
        inputType="text"
        placeholder="Please enter a name.."
        data-automation="integrationsName"
        disabled={isSaving || inherited || !userHasUpdatePermission || isMsteamsUserSyncing || !msTeamsUpdatePermission}
      />
      <InputField
        name="description"
        label="Description"
        componentType="textarea"
        inputType="text"
        data-automation="integrationsDescription"
        disabled={isSaving || inherited || !userHasUpdatePermission || isMsteamsUserSyncing || !msTeamsUpdatePermission}
      />
    </>
  );
}

DefaultForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  isMsteamsUserSyncing: PropTypes.bool,
  sidePanelUpdatePermissions: PropTypes.object,
  integrationType: PropTypes.string
};
